module.exports = __webpack_public_path__ + "img/slayer.4cde6d70.png";